import { Directive, ElementRef, Renderer2, HostListener, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DrawMapComponent } from './draw-map/draw-map.component';
import { isEmpty, forEach } from 'lodash';
import { DropdownsService, AuthenticationService } from 'app/services';
@Directive({
    selector: '[drawMap]'
})
export class DrawMapDirective {

    @Input() view = false;
    @Input() polygons: any = [];
    @Input() type: any = [];
    @Output() getPolygons: EventEmitter<any>;
    currentAgency: any;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        public _matDialog: MatDialog,
        public _dropdownService: DropdownsService,
        private _authenticationService: AuthenticationService
    ) {
        this.renderer.setStyle(this.el.nativeElement, 'cursor', 'pointer');
        this.getPolygons = new EventEmitter();
    }

    @HostListener('click') onClick(): void {
        if (isEmpty(this.polygons)) {
            this.polygons = [];
        }
        const dialogRef = this._matDialog.open(DrawMapComponent, {
            panelClass: 'drawMap-dialog',
            data: {
                polygons: this.polygons,
                view: this.view,
                type: this.type,
            },
        });
        dialogRef.afterClosed()
            .subscribe((response: any) => {
                if (response) {
                    if (!isEmpty(this.type) && this.type === 'commercial') {
                        let filter = {
                            "query": {
                                "archived": {
                                    "$ne": true
                                }
                            },
                            "options": {
                                "page": 1,
                                "limit": 20,
                                "sort": {
                                    "reference": -1
                                },
                                "rejection": false
                            },
                            "from_crm": 1,
                            "selectRecords": false
                        }
                        this._dropdownService.getCommercialWithAllLatlng(filter).subscribe((properties) => {
                            const properties_exist = new Set<string>();
                            this.currentAgency = this._authenticationService.currentAgencyValue._id;

                            response.forEach((polygon) => {
                                const vertices_x: number[] = [];
                                const vertices_y: number[] = [];

                                // Build vertices for THIS polygon only
                                polygon.forEach(point => {
                                    vertices_x.push(point.lat);
                                    vertices_y.push(point.lng);
                                });

                                const points_polygon = vertices_x.length;

                                properties.forEach(property => {
                                    if (property?.latitude && property?.longitude) {

                                        const pointLat = property.latitude;
                                        const pointLng = property.longitude;

                                        const isMatched = this.isInPolygon(points_polygon, vertices_x, vertices_y, pointLat, pointLng);

                                        if (isMatched) {
                                            properties_exist.add(property._id.toString());
                                        }
                                    }
                                });
                            });
                            this.getPolygons.next({ properties_exist: Array.from(properties_exist), response });
                        });
                    } else {
                        if (Array.isArray(response) && response.length == 0) {
                            this.el.nativeElement.blur();
                        }
                        this.getPolygons.next(response);
                    }

                }
            });
    }

    isInPolygon(points_polygon: number, vertices_x: number[], vertices_y: number[], pointLat: number, pointLng: number): boolean {

        let inside = false;

        for (let i = 0; i < points_polygon; i++) {
            const j = (i + points_polygon - 1) % points_polygon;

            const xi = vertices_x[i], yi = vertices_y[i];
            const xj = vertices_x[j], yj = vertices_y[j];

            const intersect =
                ((yi > pointLng) !== (yj > pointLng)) &&
                (pointLat < (xj - xi) * (pointLng - yi) / (yj - yi) + xi);

            if (intersect) {
                inside = !inside;
            }
        }

        return inside;
    }
}
